import { graphql } from "react-relay";

export const CreateOnboardingTaskStatusMutation = graphql`
  mutation CreateOnboardingTaskStatusMutation($input: CreateOnboardingTaskStatusInput!) {
    createOnboardingTaskStatus(input: $input) {
      taskStatus {
        id
        taskId
        status
        completedAt
        completedByUser {
          id
          firstName
          lastName
        }
      }
    }
  }
`;